import { Arrow } from '../SVGs';
import { ValImage } from '@valbuild/next';
import Link from 'next/link';
import { Employee } from '../../content/blank/allEmployees.val';

interface ContactFooterProps {
  title: string;
  link: { href: string; text: string };
  contactPeople: Employee[];
}

const ContactFooter: React.FC<ContactFooterProps> = ({
  title,
  link,
  contactPeople,
}) => {
  return (
    <div className="flex w-full justify-between flex-col tablet:flex-row gap-64 tablet:items-center">
      <div className="flex flex-col tablet:gap-24">
        <h3 className="tablet:text-xl">{title}</h3>
        <Link href={link.href} className="text-lg tablet:text-2xl">
          <span className="inline-flex gap-4 items-center">
            {link.text}
            <Arrow
              color="currentColor"
              className="h-[var(--text-lg)] tablet:h-[var(--text-2xl)] w-[var(--text-lg)] tablet:w-[var(--text-2xl)] pt-2 shrink-0"
            />
          </span>
        </Link>
      </div>

      <div className="flex  gap-16 tablet:gap-24 flex-wrap tablet:flex-nowrap">
        {contactPeople.map((person, idx) => (
          <div key={idx} className="flex flex-col gap-8">
            <ValImage
              className="object-cover w-100 h-100 laptop:max-w-[330px]"
              src={person.image}
              alt={person.image.metadata?.alt}
            />

            <div className="flex flex-col gap-4">
              <p className="text-lg tablet:text-xl">{person.name}</p>
              <p>{person.position}</p>

              <div className="flex flex-col laptop:flex-row gap-8 laptop:gap-16">
                <a href={`mailto:${person.email}`}>{person.email}</a>

                <a href={`tel:${person.phoneNumber}`}>
                  {person.phoneNumber
                    .replace(' ', '')
                    .replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactFooter;
